





















































import Vue from 'vue'
import Component from 'vue-class-component'
import { Emit, Prop, Watch } from 'vue-property-decorator'
import MapView from '../mapview/Map.vue'
import Node from '@/models/Node'
import Vector2 from '../../models/Vector2'
import ImageInput from '@/components/ImageInput.vue'
import Project from '@/models/Project'
import CvMarker from './leaflet/CVMarker.vue'
import { LMap, LTileLayer, LMarker, LIcon } from 'vue2-leaflet';
import { ElementQueries, ResizeSensor } from 'css-element-queries'

@Component({
	components: {
		CvMarker
	},
	refs: ['map']
})
export default class LeafletMap extends Vue {
	@Prop(Object) readonly projectData! : {type : string, coords : { latitude : number, longitude : number, zoom_level : number }};
	@Prop() readonly mapNodes! : any;
	
	resizeSensor: ResizeSensor | null = null;

	get mapObject()
	{
		return this.$refs.map as LMap;
	}

	mounted()
	{
		this.$nextTick(()=>{
			(this.mapObject.mapObject as any)._onResize();
			/*
			this.resizeSensor = new ResizeSensor(this.mapObject.$el, ()=>{
				this.mapObject.mapObject.invalidateSize();
			});
			*/
		})
	}

	beforeMount(){
		if (this.projectData.coords)
		{
			this.center[0] = this.projectData.coords.latitude;
			this.center[1] = this.projectData.coords.longitude;
			this.zoom = this.projectData.coords.zoom_level;
		}
	}
	url = 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}'
	attribution = 'Tiles &copy; Esri &mdash; Source: Esri, DeLorme, NAVTEQ, USGS, Intermap, iPC, NRCAN, Esri Japan, METI, Esri China (Hong Kong), Esri (Thailand), TomTom, 2012'
	zoom = 1;
	center = [0,0]
	get markers()
	{
		let res = []
		for(let kv of this.mapNodes)
		{
			let node = kv[1];
			res.push(
				{label: {color: 'white', text: node.name}, position: [node.position.y, node.position.x], node}
			);
		}
		return res;
	}

	gMapClicked(ev : any){
		let latLng = {
			lat: ev.latlng.lat,
			lng: ev.latlng.lng
		}
		this.$emit('background-click', latLng.lng, latLng.lat);
	}
}
